namespace GeniuzPOS.Purchase {
    export interface PoPurRequestRow {
        Id?: number;
        SysDocNo?: string;
        PurDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        SupplName?: string;
        ShopId?: string;
        ShipId?: string;
        ShipName?: string;
        ShipLineAddress1?: string;
        ShipLineAddress2?: string;
        ShipLineAddress3?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        VatFg?: VatFgstatus;
        TotalAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        NetAmt?: number;
        NetExVat?: number;
        NetTotalInVat?: number;
        SalesVatTypes?: string;
        VatCode?: string;
        VatRate?: number;
        VatAmt?: number;
        PurOrderAmt?: number;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveFg?: number;
        ApproveLv?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        SendForAppfg?: sendapp;
        CancelFg?: CancelFgstatus;
        RejectFg?: number;
        UseFg?: number;
        LastDateStatusChange?: string;
        Refuse?: string;
        DtList?: PoPurRequestDtRow[];
        POTypeFg?: POTypeFg;
        BranchCode?: string;
    }

    export namespace PoPurRequestRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPurRequest';
        export const lookupKey = 'Purchase.PoPurRequest';

        export function getLookup(): Q.Lookup<PoPurRequestRow> {
            return Q.getLookup<PoPurRequestRow>('Purchase.PoPurRequest');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):สร้าง:Modify';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):สร้าง:Modify';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):สร้าง:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):สร้าง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            PurDocNo = "PurDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            ShopId = "ShopId",
            ShipId = "ShipId",
            ShipName = "ShipName",
            ShipLineAddress1 = "ShipLineAddress1",
            ShipLineAddress2 = "ShipLineAddress2",
            ShipLineAddress3 = "ShipLineAddress3",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            VatFg = "VatFg",
            TotalAmt = "TotalAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            NetAmt = "NetAmt",
            NetExVat = "NetExVat",
            NetTotalInVat = "NetTotalInVat",
            SalesVatTypes = "SalesVatTypes",
            VatCode = "VatCode",
            VatRate = "VatRate",
            VatAmt = "VatAmt",
            PurOrderAmt = "PurOrderAmt",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveFg = "ApproveFg",
            ApproveLv = "ApproveLv",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            SendForAppfg = "SendForAppfg",
            CancelFg = "CancelFg",
            RejectFg = "RejectFg",
            UseFg = "UseFg",
            LastDateStatusChange = "LastDateStatusChange",
            Refuse = "Refuse",
            DtList = "DtList",
            POTypeFg = "POTypeFg",
            BranchCode = "BranchCode"
        }
    }
}
